import { Component, OnDestroy, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { UploadCoverService } from '../../providers/Table/uploadCover.service';
import { MatDialogRef } from '@angular/material/dialog';
import { MatCalendar } from '@angular/material/datepicker';

@Component({
  selector: 'app-versiondatepicker',
  templateUrl: './versionDatepicker.component.html',
  styleUrls: ['./versionDatepicker.component.scss']
})
export class VersionDatepickerComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild(MatCalendar) _datePicker: MatCalendar<Date>;

  hoveredDateLabel: string | null = null;

  constructor(private uploadCoverService: UploadCoverService,
              private dialogRef: MatDialogRef<any>) {}

  ngOnInit() {}

  ngAfterViewInit() {
    this._datePicker.selectedChange.subscribe(x => {
      this.closeDialog(x);
    });
  }

  ngOnDestroy() {}

  onCalendarMouseOver(event: MouseEvent): void {
    if (this._datePicker.currentView !== 'month') {
      this.hoveredDateLabel = null;
      return;
    }

    const cell = (event.target as HTMLElement).closest('.mat-calendar-body-cell') as HTMLElement;
    const dayText = cell?.querySelector('.mat-calendar-body-cell-content')?.textContent?.trim();
    const day = dayText ? parseInt(dayText, 10) : NaN;

    if (isNaN(day)) {
      this.hoveredDateLabel = null;
      return;
    }

    const activeDate = this._datePicker.activeDate;
    const hoveredDate = new Date(activeDate.getFullYear(), activeDate.getMonth(), day);
    this.hoveredDateLabel = this.formatFrenchDate(hoveredDate);
  }

  onCalendarMouseLeave(): void {
    this.hoveredDateLabel = null;
  }

  private formatFrenchDate(date: Date): string {
    const formatted = new Intl.DateTimeFormat('fr-FR', {
      weekday: 'long',
      day: 'numeric',
      month: 'long'
    }).format(date);
    return formatted.charAt(0).toUpperCase() + formatted.slice(1);
  }

  closeDialog(date: Date): void {
    // console.log(this._datePicker);
    const day = this.getTwoDigitDateFormat(date.getDate()).toString(),
      month = this.getTwoDigitDateFormat(date.getMonth() + 1).toString(),
      year = date.getFullYear();
    const formatedDate = year + month + day;
    this.dialogRef.close({date: formatedDate});
  }

  getTwoDigitDateFormat(monthOrDate) {
    return (monthOrDate < 10) ? '0' + monthOrDate : '' + monthOrDate;
  }

}
